import type { PlayerStats, PlayerStatsSnapshot } from '../../gameplay/player';
import { createStatRow, applyBar } from './shared';

export class ShipStatsHUD {
  readonly element: HTMLElement;
  private readonly hullFill: HTMLElement;
  private readonly hullValue: HTMLElement;
  private readonly fuelFill: HTMLElement;
  private readonly fuelValue: HTMLElement;
  private readonly unsubscribe: () => void;

  constructor(stats: PlayerStats) {
    this.element = document.createElement('div');
    this.element.className = 'stats-hud stats-hud-ship';

    const hull = createStatRow('HULL', 'stat-hull');
    const fuel = createStatRow('FUEL', 'stat-fuel');
    this.hullFill = hull.fill;
    this.hullValue = hull.value;
    this.fuelFill = fuel.fill;
    this.fuelValue = fuel.value;
    this.element.append(hull.row, fuel.row);

    this.unsubscribe = stats.subscribe((snap) => this.apply(snap));
  }

  show(): void {
    this.element.classList.add('is-visible');
  }

  hide(): void {
    this.element.classList.remove('is-visible');
  }

  dispose(): void {
    this.unsubscribe();
    this.element.remove();
  }

  private apply(snap: PlayerStatsSnapshot): void {
    applyBar(this.hullFill, this.hullValue, snap.hull, snap.hullMax);
    applyBar(this.fuelFill, this.fuelValue, snap.fuel, snap.fuelMax);
  }
}
